(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.header.classList.add('adev-sticky-' + this.getAttribute('data-sticky-type'));

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      
      let headerBoundsBottom = this.headerBounds.bottom
      let adevTransparent = document.querySelector('.adev-enable-transparent');
      if(adevTransparent) {
        headerBoundsBottom = headerBoundsBottom + adevTransparent.scrollHeight
      }

      if (scrollTop > this.currentScrollTop && scrollTop > headerBoundsBottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > headerBoundsBottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if(this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucor-custom-page"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const sections = document.querySelectorAll('[id^="lcp-tabs-"]');
    sections.forEach(section => {
      const buttons = section.querySelectorAll('.lcp-tab-btn');
      const panels  = section.querySelectorAll('.lcp-tab-panel');
      buttons.forEach(btn => {
        btn.addEventListener('click', () => {
          const idx = parseInt(btn.dataset.tab, 10);
          buttons.forEach((b, i) => b.setAttribute('aria-selected', i === idx ? 'true' : 'false'));
          panels.forEach((p, i) => p.classList.toggle('is-active', i === idx));
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucor-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  class LucorSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides    = Array.from(this.querySelectorAll('.lss-slide'));
      this.dots      = Array.from(this.querySelectorAll('.lss-dot'));
      this.pauseBtn  = this.querySelector('.lss-pause');
      this.current   = 0;
      this.timer     = null;
      this.interval  = parseInt(this.dataset.interval, 10) || 5000;
      this.autoplay  = this.dataset.autoplay !== 'false';

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) this.autoplay = false;

      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i)));
      if (this.pauseBtn) this.pauseBtn.addEventListener('click', () => this.togglePause());
      this.addEventListener('mouseenter', () => this.pause());
      this.addEventListener('mouseleave', () => { if (this.autoplay) this.play(); });
      this.addEventListener('focusin',    () => this.pause());
      this.addEventListener('focusout',   () => { if (this.autoplay) this.play(); });

      if (this.autoplay && this.slides.length > 1) this.play();
    }

    goTo(index) {
      this.slides[this.current].classList.remove('is-active');
      if (this.dots[this.current]) {
        this.dots[this.current].classList.remove('is-active');
        this.dots[this.current].setAttribute('aria-selected', 'false');
      }
      this.current = ((index % this.slides.length) + this.slides.length) % this.slides.length;
      this.slides[this.current].classList.add('is-active');
      if (this.dots[this.current]) {
        this.dots[this.current].classList.add('is-active');
        this.dots[this.current].setAttribute('aria-selected', 'true');
      }
    }

    togglePause() {
      if (this.timer) {
        this.pause();
        this.autoplay = false;
        if (this.pauseBtn) this.pauseBtn.setAttribute('aria-pressed', 'true');
      } else {
        this.autoplay = true;
        this.play();
        if (this.pauseBtn) this.pauseBtn.setAttribute('aria-pressed', 'false');
      }
    }

    play()  { this.timer = setInterval(() => this.goTo(this.current + 1), this.interval); }
    pause() { clearInterval(this.timer); this.timer = null; }
    disconnectedCallback() { this.pause(); }
  }

  if (!customElements.get('lucor-slideshow')) {
    customElements.define('lucor-slideshow', LucorSlideshow);
  }

  } catch(e) { console.error(e); }
})();
})();
